document.addEventListener('DOMContentLoaded', function() {
  const getSlidesPerView = () => {
    if (window.matchMedia('(min-width: 1280px)').matches) {
      return 6;
    } else if (window.matchMedia('(min-width: 1024px)').matches) {
      return 5;
    } else if (window.matchMedia('(min-width: 768px)').matches) {
      return 4;
    } else {
      return 3;
    }
  }

  const initMainFlickity = () => {
    var elem = document.querySelector('.video-slider__container');
    var slidesPerView = getSlidesPerView();
    var items = elem ? elem.children.length : 0;

    if (elem && items >= slidesPerView) {
      flickityMainInstance = new Flickity(elem, {
        cellAlign: 'left',
        contain: false, 
        wrapAround: true,
        pageDots: false,
        prevNextButtons: false,
        draggable: true,
        freeScroll: false,
        groupCells: false,
        initialIndex: 0,
        autoPlay: false,
        adaptiveHeight: true 
      });
    }
  }

  initMainFlickity();

  window.addEventListener('resize', function() {
    initMainFlickity();
  });
});